import React from "react"
import moment from "moment"

import { ResultDisplay } from "../../enquiry-ingest/_components/result-display"

// Reuse the AI panel + ingest result styles so the enquiry-page tab looks
// identical to the parse modal on the Enquiry Ingest page.
import "../../communications/_components/ai-tools/panel.scss"
import "../../enquiry-ingest/enquiry-ingest.scss"

/**
 * Read-only view of the AI parser's output for an enquiry.
 *
 * Reads from the `ai_parsing` map written by the Enquiry Ingest tool
 * (`persistWebsiteEnquiryParse`). Renders with the exact same `<ResultDisplay>`
 * the parse modal uses, so the two surfaces stay in lockstep — adding a new
 * field/prediction to the parser only needs render changes in one place.
 */
function ParsingResults({ aiParsing }) {
	if (!aiParsing) return null

	const parsedAt = aiParsing.parsed_at?.seconds
		? moment.unix(aiParsing.parsed_at.seconds).format("D MMM YYYY, HH:mm")
		: null

	// `<ResultDisplay>` expects the same envelope `runEmailAiTool` returns,
	// so reshape the saved fields into that.
	const result = {
		output_text: aiParsing.output_text || "",
		parsed: aiParsing.result || null,
		model_used: aiParsing.model || null,
		usage: aiParsing.usage || null,
	}

	const fields = aiParsing.settings?.fields || []
	const predictions = aiParsing.settings?.predictions || []

	return (
		<div className="enquiry-parsing-results">
			{parsedAt && (
				<p className="enquiry-parsing-results-meta">
					<strong>Parsed:</strong> {parsedAt}
				</p>
			)}

			<ResultDisplay
				result={result}
				fields={fields}
				predictions={predictions}
			/>
		</div>
	)
}

export default ParsingResults
